import React, { useEffect, useReducer, useState } from "react";
import "./DashboardConfrimNotRegisterPage.css";
import {
  Button,
  Center,
  Checkbox,
  Divider,
  Group,
  Image,
  Table,
  Text,
  Title,
} from "@mantine/core";
import { useNavigate } from "react-router-dom";
import AppModelConfrimSave from "../../(dialogs)/AppModelConfrimSave";
import { IconX } from "@tabler/icons-react";
import DetailUser from "../component/DetailUser";
import AppModelConfrimRemove from "../../(dialogs)/AppModelConfrimRemove";
import { useForm } from "@mantine/form";
import { url } from "../../settings/linkUrl";

interface RowDataUser {
  id: string;
  url: string;
  faculty: string;
  programe: string;
  short_name: string;
  name: string;
  role: string;
}

interface RowMoney {
  register: string;
  photo: string;
  set: string;
  food: string;
  rentset: string;
  register_and_photo: string;
  frm_register: string;
  frm_photo: string;
  frm_set: string;
  frm_rentset: string;
  frm_register_and_photo: string;
  frm_register_food: string;
}

export default function DashboardConfrimNotRegisterPage() {
  const nav = useNavigate();
  const [dataUser, SetdataUser] = useState<RowDataUser>();
  const [dataMoney, SetdataMoney] = useState<RowMoney>();

  const [valueRegister, setValueRegister] = useState<string[]>(["1"]);
  const [valueSet, setValueSet] = useState<string[]>(["0"]);
  const [valueSetFood, setValueSetFood] = useState<string[]>(["0"]);
  const [valueRentset, setValueRentset] = useState<string[]>(["0"]);

  const form = useForm({
    initialValues: {
      register: "0",
      photo: "0",
      set: "0",
      rentset: "0",
      register_and_photo: "0",
      register_food: "0",
    },
  });

  const initialState = {
    loading: "",
    error: "",
    data: [],
  };

  function apiReducer(state: any, action: any) {
    switch (action.type) {
      case "DATA_FETCH_START":
        return { ...state, loading: "yes" };
      case "DATA_FETCH_SUCCESS":
        return { ...state, loading: "", data: action.payload };
      case "DATA_FETCH_FAILURE":
        return { ...state, loading: "", error: action.payload };
      default:
        return state;
    }
  }

  const [data, dispatch] = useReducer(apiReducer, initialState);

  const confrimRegister = () => {
    dispatch({ type: "DATA_FETCH_START" });
    const token = localStorage.getItem("token");
    const requestOptions = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    };
    fetch(`${url}register/updateregister`, requestOptions)
      .then((respone) => {
        if (!respone.ok) throw Error(respone.statusText);
        return respone.json();
      })
      .then((json) => {
        dispatch({ type: "DATA_FETCH_SUCCESS", payload: json });
        nav(`/dashboard/register-detail`);
      })
      .catch((error) => {
        dispatch({ type: "DATA_FETCH_FAILURE", payload: error.message });
      });

    nav(`/dashboard/confrim-register`);
  };

  const cancelRegister = () => {
    nav(`/dashboard/select-not-register`);
  };

  const LoadPage = () => {
    let rr: any = localStorage.getItem("dataUser");
    SetdataUser(JSON.parse(rr));

    dispatch({ type: "DATA_FETCH_START" });
    const token = localStorage.getItem("token");
    const requestOptions = {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    };
    fetch(`${url}register/checknotdetail`, requestOptions)
      .then((respone) => {
        if (!respone.ok) throw Error(respone.statusText);
        return respone.json();
      })
      .then((json) => {
        dispatch({ type: "DATA_FETCH_SUCCESS", payload: json });
        SetdataMoney(json);
        form.setFieldValue("register", json.frm_register);
        form.setFieldValue("photo", json.frm_photo);
        form.setFieldValue("set", json.frm_set);
        if (json.frm_set === "1") {
          setValueSet(["1"]);
        }
        if (json.frm_rentset === "1") {
          setValueRentset(["1"]);
        }
        if (json.frm_register_food === "1") {
          setValueSetFood(["1"]);
        }


        form.setFieldValue("rentset", json.frm_rentset);
        form.setFieldValue("register_and_photo", json.frm_register_and_photo);
        form.setFieldValue("register_food", json.frm_register_food);
      })
      .catch((error) => {
        dispatch({ type: "DATA_FETCH_FAILURE", payload: error.message });
      });
  };

  useEffect(() => {
    LoadPage();
  }, []);

  return (
    <div className="DashboardSelectRegisterPage">
      <section>
        <DetailUser />
      </section>
      <Divider my="xs" size="sm" color="red" />
      <Center>
        <Text c="red" size="lg">
          รายการที่ท่านประสงค์
        </Text>
      </Center>

      <Divider my="xs" size="sm" color="red" />
      <section>
        <Table w="100%" layout="fixed" withRowBorders={false}>
          <Table.Thead>
            <Table.Tr>

              <Table.Th w="62%">Description</Table.Th>
              <Table.Th w="22%" ta="center">Amount (Bath)</Table.Th>
              <Table.Th w="16%" ta="center">Click</Table.Th>
            </Table.Tr>
          </Table.Thead>
          <Table.Tbody>
            <Table.Tr>
              <Table.Td>
                <Text c="blue" size="lg">
                  ค่าถ่ายรูปหมู่บัณฑิต พร้อมกรอบหลุยส์ 2 ภาพ
                </Text>
                <ul>
                  <li>ภาพขนาด 12 x 24-28 นิ้ว จำนวน 1 ภาพ</li>
                  <li>ภาพขนาด 12 x 18 นิ้ว  จำนวน 1 ภาพ</li>
                </ul>
              </Table.Td>
              <Table.Td ta="center">{dataMoney?.photo}</Table.Td>
              <Table.Td ta="center">
                <Checkbox
                  disabled
                  checked={form.values.photo === "1"}
                  color="cyan"
                  readOnly
                />
              </Table.Td>
            </Table.Tr>
            <Table.Tr>
              <Table.Td>
                <Text c="blue" size="lg">
                  ค่าตัดชุดครุยวิทยฐานะและเข็มวิทยฐานะ
                </Text>
                <ul>
                  <li>ชุดครุยวิทยาฐานะของมหาวิทยาลัยราชภัฏกำแพงเพชร</li>
                  <li>เข็มตรามหาวิทยาลัยราชภัฏกำแพงเพชร</li>
                </ul>
                <Text size="sm" c="red">
                  *หมายเหตุ หากสั่งจองนอกระบบกับสำนักบริการวิชาการและจัดหารายได้ไว้แล้ว
                  ไม่ต้องเลือกรายการนี้ หากเลือกจะไม่มีการคืนเงิน
                </Text>
              </Table.Td>
              <Table.Td ta="center">{dataMoney?.set}</Table.Td>
              <Table.Td ta="center">
                <Checkbox
                  disabled
                  checked={valueSet.includes("1")}
                  color="cyan"
                  readOnly
                />
              </Table.Td>
            </Table.Tr>
            {/* <Table.Tr>
              <Table.Td>
                <Text c="blue" size="lg">
                  ค่าอาหารงานเลี้ยงสังสรรค์บัณฑิตใหม่
                </Text>
                <ul>
                  <li>ของที่ระลีก</li>
                  <li>อาหารโต๊ะจีน</li>
                </ul>
              </Table.Td>
              <Table.Td ta="center">{dataMoney?.food}</Table.Td>
              <Table.Td ta="center">
                <Checkbox
                  disabled
                  checked={valueSetFood.includes("1")}
                  color="cyan"
                  readOnly
                />
              </Table.Td>
            </Table.Tr> */}
          </Table.Tbody>
        </Table>
      </section>
      <Group justify="center" mt="md">
        <AppModelConfrimSave
          onLoadPage={confrimRegister}
          nameBtn="ยืนยันการลงทะเบียน"
        />
        <AppModelConfrimRemove
          onLoadPage={cancelRegister}
          nameBtn="แก่ไขข้อมูล"
        />
      </Group>
    </div>
  );
}
